var map = {
	"./banhanguytin/7.png": "2fe1",
	"./cacung/7.png": "7497",
	"./chuyencan/7.png": "e7ad",
	"./daigiadataha/7.png": "3688",
	"./duhanhgia/7.png": "b411",
	"./thanhsanma/7.png": "ed41"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9bec";